import { createContext, useContext } from 'react';

/**
 * Whether the keep-alive tab panel that owns the current React tree is the
 * active dashboard tab. Inactive panels stay mounted but are hidden; MUI
 * Dialog/Drawer portals escape that hide, so consumers must gate `open` with
 * this flag to avoid stacked modals across tabs.
 *
 * Defaults to `true` outside {@link TabWorkspaceHost} (standalone routes, tests).
 */
export const TabPanelActiveContext = createContext(true);

export const useTabPanelActive = (): boolean => useContext(TabPanelActiveContext);

/**
 * Keeps parent `open` state intact while the tab is inactive, but tells MUI the
 * modal is closed so it does not portal/trap focus over another tab.
 */
export const useTabScopedOpen = (open: boolean): boolean => {
  const isTabActive = useTabPanelActive();
  return open && isTabActive;
};
